<template>
	<li class="m-nav__item m-topbar__user-profile  m-dropdown m-dropdown--medium m-dropdown--arrow m-dropdown--align-right m-dropdown--mobile-full-width m-dropdown--skin-light" m-dropdown-toggle="click">
		<a href="#" class="m-nav__link m-dropdown__toggle">
			<span class="m-topbar__userpic m--hide">
				<avatar-component :round="true" size="40" :name="this.user.username" :letter="this.getDisplayName"></avatar-component>
			</span>
			<span class="m-nav__link-icon m-topbar__usericon">
				<span class="m-nav__link-icon-wrapper"><i class="fa fa-user-circle"></i></span>
			</span>
			<span class="m-topbar__username m--hide">{{this.user.username}}</span>
		</a>
		<div class="m-dropdown__wrapper">
			<span class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust"></span>
			<div class="m-dropdown__inner">
				<div class="m-dropdown__header m--align-center">
					<div class="m-card-user m-card-user--skin-light">
						<div class="m-card-user__pic">
							<avatar-component :round="true" size="60" :name="this.user.username" :letter="this.getDisplayName"></avatar-component>
						</div>
						<div class="m-card-user__details">
							<span class="m-card-user__name m--font-weight-500">{{this.user.username}}</span>
							<a href="javascript:;" class="m-card-user__email m--font-weight-300 m-link d-none d-xl-block">Cấp độ: {{this.user.role}}</a>
						</div>
					</div>
				</div>
				<div class="m-dropdown__body">
					<div class="m-dropdown__content">
						<ul class="m-nav m-nav--skin-light">
							<li class="m-nav__item">
								<a href="javascript:;" class="m-nav__link">
									<i class="m-nav__link-icon flaticon-piggy-bank"></i>
									<span class="m-nav__link-text user-info">Còn lại {{this.remainBudget}}</span>
								</a>
							</li>
							<li class="m-nav__item">
								<a href="javascript:;" class="m-nav__link">
									<i class="m-nav__link-icon flaticon-lifebuoy"></i>
									<span class="m-nav__link-text">Liên hệ</span>
								</a>
							</li>
							<li class="m-nav__item">
								<a href="javascript:;" @click="this.showChangePassModal" class="m-nav__link">
									<i class="m-nav__link-icon flaticon-lock"></i>
									<span class="m-nav__link-text">Đổi mật khẩu</span>
								</a>
							</li>
							<li class="m-nav__separator m-nav__separator--fit">
							</li>
							<li class="m-nav__item">
								<a href="javascript:;" @click="logout()" class="btn m-btn--pill btn-secondary m-btn m-btn--custom m-btn--label-brand m-btn--bolder">Đăng xuất</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</li>
</template>

<script>
	import { mapGetters } from 'vuex';
	import Avatar from "./Avatar";
	import { Utilities } from "../utilities";

	export default {
		computed: {
			...mapGetters({
		  		user: 'user',
		  		userBudget: 'userBudget'
			}),

			getDisplayName(){
				if(this.user.role == "admin" || this.user.role == "house"){
					return this.user.username[0];
				}

				return this.user.username.slice(0,1);
			},

			budget(){
				return Utilities.formatNumber(this.userBudget.budget);
			},

			usedBudget(){
				return Utilities.formatNumber(this.userBudget.budget - this.userBudget.remain);
			},

			remainBudget(){
				return Utilities.formatNumber(this.userBudget.remain);
			}
		},

		components: {
			'avatar-component': Avatar
		},

		methods: {
			showChangePassModal: function(){
	    		$("#change_pass_modal").modal();
	    	},

	    	logout: function(){
	    		localStorage.clear();
	    		this.$router.replace({name: "LoginPage"});
	    	}
		}
	}
</script>

<style>
	.m-nav .m-nav__item>.m-nav__link .user-info {
		display: inline;
	    padding-left: 5px;
	    font-size: 15px;
	}
</style>